import React from 'react';
export function PhoneFrame({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen w-full bg-slate-100 flex justify-center" data-id="element-146">
      <div className="w-full max-w-[390px] min-h-screen bg-white shadow-xl relative overflow-hidden" data-id="element-147">
        {children}
      </div>
    </div>;
}